<template>
  <div>      
      <CRow>
        <CCol md="12" class="text-center">
            <skew-loader :loading="true" color="black" ></skew-loader>
            <strong><CIcon name="cil-ban"/> This feature coming soon. Meanwhile please use BBMP Children Survey app to enter data.</strong>
        </CCol>
    </CRow>   
    <!-- <CRow>
        <CCol md="8">
            <CCard>
                <CCardHeader>
                    <strong>New Human Wildlife Conflict Entry</strong>
                </CCardHeader>
                <CCardBody>
                    <CForm>
                        <CInput
                            description="CASE ID is automatically generated. But you can edit this."
                            label="CASE ID"
                            horizontal
                        />
                        <CSelect
                            label="Animal"
                            horizontal
                            :options="animalOptions"
                            placeholder="Please select which animal is responsible for conflict"
                        />
                        <CInput
                            description="How many number of animals were there?"
                            label="Animal Count"
                            horizontal
                            type="number"
                            value=0                            
                        />
                        <CSelect
                            label="Scenario"
                            horizontal
                            :options="scenarioOptions"
                            placeholder="Please select what is the scenario"
                        />
                        <CInput
                            label="Date of Incident"
                            type="date"
                            horizontal
                        />
                        <CInput
                            label="Time of Incident"
                            type="time"
                            horizontal
                        />
                        <CInput
                            description="Lattitude of the incident"
                            label="Lattitude"
                            horizontal
                            type="number"
                            value=0                            
                        />
                        <CInput
                            description="Longitude of the Incident"
                            label="Longitude"
                            horizontal
                            type="number"
                            value=0                            
                        />
                        <CInput
                            description="Address of the incident"
                            label="Address"
                            horizontal                           
                        />
                        <CInputFile
                            label="Image"
                            horizontal
                            custom
                            
                        />
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton type="submit" size="sm" color="primary" style="float : right"><CIcon name="cil-check-circle"/> Submit</CButton>
                    <CButton type="reset" size="sm" color="danger" style="float : left"><CIcon name="cil-ban"/> Reset</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>    -->
  </div>
</template>

<script>
import SkewLoader from 'vue-spinner/src/SkewLoader.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
export default {
  name: 'NewEntry',
  components: {
    SkewLoader,
    PulseLoader
  },
  data () {
    return {
        time : '',
      selected: [], // Must be an array reference!
      show: true,
      horizontal: { label:'col-3', input:'col-9' },
      options: ['Option 1', 'Option 2', 'Option 3'],
      animalOptions : ['Elephant', 'Tiger', 'Leopard', 'Wild Boar'],
      scenarioOptions : ['Emergency', 'Human Death', 'Human Injury', 'Livestock Kill', 'Animal Sighted'],
      selectOptions: [
        'Option 1', 'Option 2', 'Option 3',
        { 
          value: 'some value', 
          label: 'Selected option'
        }
      ],
      selectedOption: 'some value',

      formCollapsed: true,
      checkboxNames: ['Checkboxes', 'Inline Checkboxes',
                      'Checkboxes - custom', 'Inline Checkboxes - custom'],
      radioNames: ['Radios', 'Inline Radios',
                    'Radios - custom', 'Inline Radios - custom']
    }
  },
  methods: {
    validator (val) {
      return val ? val.length >= 4 : false
    }
  }
}
</script>
